import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-box">
      <h2 className="about-heading">📍 About Us</h2>
      <p className="about-text">
        Welcome to <strong>Kashmir Jobs</strong> – your trusted source for job updates and employment opportunities across Jammu & Kashmir.
      </p>
      <p className="about-text">
        Our mission is to empower students, freshers, and experienced professionals by connecting them with relevant job openings and career resources.
      </p>
      <p className="about-text">
        Whether you're looking for government jobs, private sector roles, internships, or freelance work – we’re here to support your journey every step of the way.
      </p>
    </div>
  );
};

export default About;
